export default {
  CLEAR(state) {
    state.properties = [];
  },
  SET_PROPERTIES(state, properties) {
    state.properties = properties;
  },
};
